import { TaskStatus } from "@remi/enums/task-status";

export const actionableStatuses: TaskStatus[] = [TaskStatus.IN_PROGRESS, TaskStatus.TO_DO];
